import request from './http'
const baseUrl = '/apass-base'
const businessUrl = '/apass-business'
export const getRegionAll = () =>
  request({
    url: baseUrl + '/api/region/all',
    method: 'get'
  })
export const getUploadToken = (bucketType) =>
  request({
    url: businessUrl + `/api/fileStorage/getToken/${bucketType}`,
    method: 'get'
  })
export const qiniuUpload = (data) =>
  request({
    url: 'https://up.qbox.me',
    method: 'post',
    data
  })
export const qiniuUpload1 = (data, data1) =>
  request({
    url: data1,
    method: 'post',
    data
  })
  
